/*eslint-disable*/
export default [
    {
        path: 'bonus-games/list',
        name: 'bonus-games:list',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/lists/List.vue'),
        meta: {
            title: 'router.router_bonusGames',
            prev: {
                name: 'dashboard'
            }
        },
        props ($route) {
            return {
                type: 'bonus-games',
                page: $route.query.page,
                withoutCreate: false,
            }
        }
    },

    {
        path: 'bonus-games/bonuses/list',
        name: 'bonus-games/bonuses:list',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/lists/List.vue'),
        meta: {
            title: 'router.router_bonuses',
            prev: {
                name: 'dashboard'
            }
        },
        props ($route) {
            return {
                type: 'bonuses',
                page: $route.query.page,
                withoutCreate: false,
            }
        }
    },
    {
        path: 'bonus-games/bonuses/create',
        name: 'bonuses:create',
        component: () => import('../../components/bonusGames/bonuses/Create.vue'),
        meta: {
            title: 'router.router_bonuses',
            prev: {
                name: 'bonus-games/bonuses:list'
            }
        },
        props ($route) {
            return {
                copy: $route.params.copy,
                page: $route.query.page,
                type: $route.params.type || 'bonuses',
            }
        }
    },
    {
        path: 'bonus-games/bonuses/:id/edit',
        name: 'bonuses:edit',
        component: () => import('../../components/bonusGames/bonuses/Create.vue'),
        meta: {
            title: 'router.router_bonuses',
            prev: {
                name: 'bonus-games/bonuses:list'
            }
        },
        props ($route) {
            return {
                id: $route.params.id,
                type: $route.params.type || 'bonuses',
                page: $route.query.page,
                copy: $route.params.copy,
            }
        }
    },
]
